import './dialog.module.scss';
import MaterialDialog from '@mui/material/Dialog';
import MaterialDialogContent from '@mui/material/DialogContent';
import MaterialDialogContentText from '@mui/material/DialogContentText';
import MaterialDialogTitle from '@mui/material/DialogTitle';
import MaterialDialogActions from '@mui/material/DialogActions';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/* eslint-disable-next-line */
export interface DialogProps {
  open: boolean,
  // ariaDescribedby?: string,
  // ariaLabelledby?: string,
  // BackdropComponent?: any,
  breakpoint?: any,
  children: any,
  // classes?: object,
  // disableEscapeKeyDown?: boolean,
  // fullScreen?: boolean,
  fullWidth?: boolean,
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | false,
  // onBackdropClick?: any,
  onClose?: (event: CloseEvent, reason: string) => void,
  // PaperComponent?: any,
  // PaperProps?: object,
  // scroll?:'body'| 'paper',
  sx?: any,
  // TransitionComponent?: any,
  // transitionDuration?: number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object
  'data-testid'?: string
}

export interface DialogTitleProps {
  children: any,
  // classes?: object,
  sx?: any,
  className?: string
}

export interface DialogContentProps {
  children: any,
  // classes?: object,
  dividers?: boolean,
  sx?: any
}

export interface DialogContentTextProps {
  children: any,
  // classes?: object,
  sx?: any
}

export interface DialogActionsProps {
  children: any,
  // classes?: object,
  // disableSpacing?: boolean,
  sx?: any
}

export function Dialog(props: DialogProps) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(props.breakpoint || 'sm'));
  // console.log(theme.breakpoints.down(props.breakpoint || 'md'));
  // console.log(props.breakpoint || 'md');

  return (
    <MaterialDialog
      open={props.open || false}
      onClose={props.onClose}
      maxWidth={props.maxWidth || false}
      fullWidth={props.fullWidth}
      fullScreen={fullScreen}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialDialog>
  );
}

export function DialogTitle(props: DialogTitleProps) {
  return (
    <MaterialDialogTitle
      className={props.className}
      sx={props.sx}>
      {props.children}
    </MaterialDialogTitle>
  );
}

export function DialogContent(props: DialogContentProps) {
  return (
    <MaterialDialogContent
      dividers={props.dividers}
      sx={props.sx}>
      {props.children}
    </MaterialDialogContent>
  );
}

export function DialogContentText(props: DialogContentTextProps) {
  return (
    <MaterialDialogContentText
      sx={props.sx}>
      {props.children}
    </MaterialDialogContentText>
  );
}

export function DialogActions(props: DialogActionsProps) {
  return (
    <MaterialDialogActions
      sx={props.sx}>
      {props.children}
    </MaterialDialogActions>
  );
}

export default Dialog;